/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import React from 'react';
import {DIYOperationStatus, withStatus} from './DIYStatusPage';
import {Button} from '@scuf/common';
import './DIYErrorPage.scss';

/**
 * Additional navigation/invocation items for the error screen
 */
export interface INavigationButton {

  /**
   * The content inside the button
   */
  content: string;

  /**
   * The callback function for the button
   * @returns {{}}
   */
  onClick: () => void;
}

/**
 * The properties for the errro page
 */
export interface IDIYErrorPageProps {
  /**
   * The errorTitle for the error screen
   */
  errorTitle: string;

  /**
   * An optional status message to be displayed with
   * the errorTitle and icon
   */
  message?: string;

  /**
   * Show a link to support page
   */
  showSupportLink?: boolean;

  /**
   * Handler for the support function
   */
  supportHandler?: () => void
  /**
   * Additional navigation buttons
   */
  additionalNavButtons?: INavigationButton[];
}

/**
 * The standard error page for the application
 * It renders the following content
 * 1. errorTitle
 * 2. error/warning icon
 * 3. message
 * 4. contact support (configurable through flag)
 * 5. list if additional navigation options
 * @param {IDIYErrorPageProps} props
 * @constructor
 */
export const DIYErrorPage = (props: IDIYErrorPageProps) => {

  // Instantiate a blank element wrapped inside status
  const ErrorContent = withStatus(() => {
    return <></>;
  });

  /**
   * Return the React element for the navigation buttons
   * @returns {JSX.Element}
   */
  const navigationButtonsElement = (): JSX.Element => {
    let navButtons = props.additionalNavButtons || [];
    return <React.Fragment>
      <div className="ui-error-navigation">
        {
          (props.showSupportLink && !!props.supportHandler) ? <Button type='primary'
                                            content="Contact Support" onClick={props.supportHandler}/> : <></>
        }
        {
          navButtons.map((navButton: INavigationButton, index: number) => {
            return <Button content={navButton.content}
                           type='secondary'
                           onClick={navButton.onClick}></Button>;
          })
        }
      </div>
    </React.Fragment>;
  };

  let needsNavigationArea = props.showSupportLink || (props.additionalNavButtons && props.additionalNavButtons.length > 0);
  let layoutClass = (needsNavigationArea) ? 'application-page-content' : 'application-page-content-no-nav';
  return (
    <React.Fragment>
      <div className={`${layoutClass} ui-error-container`}>
        <ErrorContent title={props.errorTitle} message={props.message}
                      status={DIYOperationStatus.IMPORTANT} key={0}/>
      </div>
      {
        (needsNavigationArea) ? <div className='application-navigation ui-box-shadow'>
          {
            navigationButtonsElement()
          }
        </div> : <></>
      }
    </React.Fragment>);
};


